import { FunctionComponent } from 'react';
import { Stack } from '@mui/material';
import { Site } from '@/core/entities';

const AddressCityCell: FunctionComponent<Pick<Site, 'address' | 'city'>> = ({ address, city }) => (
	<Stack direction="column">
		<span>{address}</span>
		<span>{city}</span>
	</Stack>
);

export default AddressCityCell;
